<template>
  <div id="app">
    <LoginBackground />
    <div id="login">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 offset-sm-3 box-container bg-white">
            <h2>Aurora Creator</h2>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="username">Name</label>
                <input
                  type="text"
                  v-model="username"
                  name="username"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !username }"
                />
                <div v-show="submitted && !username" class="invalid-feedback">
                  Name is required
                </div>
              </div>
              <div class="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  v-model="password"
                  name="password"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !password }"
                />
                <div v-show="submitted && !password" class="invalid-feedback">
                  Password is required
                </div>
              </div>
              <div class="form-group">
                <button class="btn" :disabled="loading">
                  <span>Login</span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6667 17.3335L20.0001 12.0002L14.6667 6.66683"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 12.0002L4 12.0002"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <img
                  v-show="loading"
                  src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                />
              </div>
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { router } from "../_helpers";
import { userService } from "../_services";
import LoginBackground from "../components/LoginBackground.vue";
export default {
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      returnUrl: "",
      error: "",
    };
  },
  components: {
    LoginBackground,
  },
  created() {
    // reset login status
    userService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      const { username, password } = this;

      // stop here if form is invalid
      if (!(username && password)) {
        return;
      }

      this.loading = true;
      userService.login(username, password).then(
        (user) => router.push(this.returnUrl),
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .box-container {
    padding: 64px;
    margin: 0 auto;
    h2 {
      font-size: 48px;
      line-height: 56px;
      margin-bottom: 40px;
    }
    label {
      font-size: 16px;
      margin-bottom: 4px;
    }
    .form-group {
      margin-bottom: 24px;
      &:nth-child(2) {
        margin-bottom: 40px;
      }
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    input {
      font-size: 18px;
      padding: 12px;
      line-height: 120%;
    }
    button {
      display: flex;
      align-items: center;
      background-color: #5a5ccd;
      border-radius: 26px;
      color: #fff;
      font-size: 20px;
      line-height: 28px;
      padding: 12px 24px;
      span {
        margin-right: 8px;
      }
    }
  }
}
</style>
